import React, { Component } from "react";
import ProjectsView from "../views/ProjectsView";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../state/actions/actions";
import { withRouter } from "react-router-dom"

const mapStateToProps = state => {
  return {
    data: state.data,
    projectPage: state.projectPage,
    filter: state.filter,
    loadedThumbs: state.loadedThumbs,
    loaderHidden: state.loaderHidden,
    mobile: state.mobile,
    showThumbs: state.showThumbs,
    breakpointXL: state.breakpointXL,
    breakpointXXL: state.breakpointXXL,
    isProject: state.isProject,
    menuAnimating: state.menuAnimating
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      actions,
      dispatch
    )
  };
};

class ProjectsContainer extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return <ProjectsView {...this.props} />
  }
}
  
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectsContainer);